import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { PosIntegrationService } from '../../../../../../../services/pos-integration.service';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rental-payment-status',
  templateUrl: './rental-payment-status.component.html',
  styleUrls: ['./rental-payment-status.component.scss'],
})
export class RentalPaymentStatusComponent implements OnInit {
  @Input() partner;
  @Input() countryData;
  @Input() reservation;
  @Input() reservationPaymentHistory;
  @Input() invoice = null;
  @Input() qrCodeURL = null;
  @Output() reloadReservation = new EventEmitter();
  public busySyncing: boolean = false;
  public markingAsPaid: boolean = false;
  public hasRefund: boolean = false;
  public canRefund: boolean = false;
  public showInitiateRefundDialog: boolean = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private rentalsService: RentalsService,
    public messageService: MessageService,
    private translate: TranslateService,
  ) { }


  ngOnInit() {
    console.log(this.reservationPaymentHistory)
    if (this.invoice && this.invoice.id) {
      this.reloadReservation.emit({});
    }    
  }

  ngOnChanges(changes: SimpleChanges) {
    var paymentsTotal = 0;
    var refundsTotal = 0;
    this.reservationPaymentHistory.filter((x:any)=>{return x.paymentMethod === "STRIPE"}).forEach(payment => {
      paymentsTotal += payment.amountPaid;
      if (payment.refunds && payment.refunds.length > 0) {
        this.hasRefund = true;
        refundsTotal += payment.refunds.map((x: any) => { return x.amountRefunded }).reduce((acc, num) => acc + num, 0);
      }
      if (payment.paymentMethod === "STRIPE") {
        this.canRefund = true;
      }
    });
    if (this.canRefund && refundsTotal >= paymentsTotal) {
      this.canRefund = false;
    }
  }

  syncPayments() {
    this.busySyncing = true;
    if (this.partner.POSSystemID <= 10) {
      this.posIntegrationService.syncPOSPayments(this.partner.ID, this.reservation.id).subscribe(res => {
        this.reloadReservation.emit({});
        this.busySyncing = false;
      }, err => {
        this.busySyncing = false;
      });
    } else {
      this.posIntegrationService.syncNewPOSPayments(this.partner.ID, this.invoice.id).subscribe(res => {
        this.reloadReservation.emit({});
        this.busySyncing = false;
      }, err => {
        this.busySyncing = false;
      });
    }
  }

  canHandlePayments() {
    return this.partner.POSSystemID === 3 || this.partner.POSSystemID === 6 || this.partner.POSSystemID === 9 || this.partner.POSSystemID === 12 || this.partner.POSSystemID === 19 || this.partner.POSSystemID === 17;
  }

  markAsPaid() {
    this.markingAsPaid = true;
    this.rentalsService
      .updateReservationPaymentStatus(this.reservation.id)
      .subscribe(
        (data) => {
          this.reloadReservation.emit({});
          this.invoice.paymentStatus = 10;
          this.markingAsPaid = false;
        },
        (err) => {
          this.markingAsPaid = false;
        },
      );
  }

  hasPaymentsNotSyncd() {
    return (
      this.reservationPaymentHistory.filter((x) => {
        return !x.paymentSentToPOS;
      }).length > 0
    );
  }

  syncLongTermPayments() {
    this.busySyncing = true;
    this.posIntegrationService
      .syncLongTermPOSPayments(this.partner.ID, this.reservation.id)
      .subscribe(
        (res) => {
          this.reloadReservation.emit({});
          this.busySyncing = false;
        },
        (err) => {
          this.busySyncing = false;
        },
      );
  }

  openPaymentLink() {
    window.open(this.qrCodeURL, '_blank');
  }

  initiateRefund(){
    this.showInitiateRefundDialog = true;
  }

  refundComplete(){
    this.showInitiateRefundDialog = false;
    this.reloadReservation.emit({});
    this.messageService.add({
      life: 5000,
      detail: this.translate.instant(
        'bikeshop.modal.initiate_refund.refund_complete'
      ),
    });
  }
}
